import { carleadCreationGetInitialProps } from '@wkda/carlead-creation-components';
import {
  BaseConversationalLeadPage,
  CarleadHIWWhyChooseWkdaFaq,
} from '@wkda/marketing-components';
import { defaultFlowWithoutConsent } from '@wkda/conversational-carlead';

function CarleadCreation() {
  return (
    <BaseConversationalLeadPage
      form={defaultFlowWithoutConsent}
      content={CarleadHIWWhyChooseWkdaFaq}
      showTerms={true}
      showTrustPilot={true}
      howItWorksShowCta={false}
    />
  );
}

CarleadCreation.getInitialProps = carleadCreationGetInitialProps;

export default CarleadCreation;
